import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  case_id: '',
  last_edited: null,
  status: 1,
  additional_recipients: '',
  confirmations: {},
  comment: '',
  approvals: {},
  payment: {},
  name: '',
  instrument_id: '',
  publish_here: false,
  publish_on: null,
  is_already_published: false,
  already_published_location: '',
  already_published_date: null,
  paper_version: '',
  issue_type: null,
  stock_exchange: null,
  issue_date: null,
  type: null,
  foreign_type: null,
  scheme: null,
  issuer_name: '',
  issuers: [],
  guarantors: '',
  invoice: {
    issuer_name: '',
    first_name: '',
    last_name: '',
    address_line_1: '',
    address_line_2: '',
    postcode: '',
    city: '',
    country: null,
    invoice_type: 1,
  },
  maturity_date: null,
  security_type: null,
  declaration_files: [],
  prospectus_files: [],
  incorporated_files: [],
  additional_files: [],
  final_terms_files: [],
};

const requestSlice = createSlice({
  name: 'request',
  initialState,
  reducers: {
    updateRequestField: (state, { payload }) => {
      return { ...state, ...payload };
    },
    clearForm: () => {
      return { ...initialState };
    },
    submitEntry: (state, { payload }) => {
      state.status = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('user/clearFormOnLogout', () => {
      return { ...initialState };
    });
  },
});

export const { updateRequestField, clearForm, submitEntry } = requestSlice.actions;
export default requestSlice.reducer;
